import {Component, EventEmitter, OnInit, Output, forwardRef, Input} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS
} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {BillofladingAddressesComponent} from '../billoflading-addresses/billoflading-addresses.component';
import {HhgBillOfLadingService} from 'src/app/services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'app-billoflading-information',
    templateUrl: './billoflading-information.component.html',
    styleUrls: ['./billoflading-information.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BillofladingInformationComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BillofladingInformationComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class BillofladingInformationComponent implements ControlValueAccessor, OnInit {

  @Input() shipmentInfoIdFromUrl: any;
  @Input() routedFrom: any;
  @Input() selectedShipmentType: any;
  bsModalRef: BsModalRef;
  billOfLadingInfo: UntypedFormGroup;
  isPOVShipmentType = false;
  isHhgShipmentType = false;
  isUABShipmentType = false;
  minDate = new Date();
  shipmentTypeArray: any[];
  isHHGSelected: boolean;
  isUABSelected: boolean;
  isPOVSelected: boolean;

  hhgBillOfLadingReview$ = this.hhgBillOfLadingService.hhgBillOfLadingReview$
    .pipe(
      tap(hhgBillOfLadingReview => {
        setTimeout(() => {
          if (hhgBillOfLadingReview.moveDate != null) {
            hhgBillOfLadingReview['moveDateFormatted'] = new Date(hhgBillOfLadingReview.moveDate).toLocaleDateString();
          }
          if (hhgBillOfLadingReview.requestedPackDate != null) {
            hhgBillOfLadingReview['requestedPackDateFormatted'] = new Date(hhgBillOfLadingReview.requestedPackDate).toLocaleDateString();
          }
          if (hhgBillOfLadingReview.requiredDeliveryDate != null) {
            hhgBillOfLadingReview['requiredDeliveryDateFormatted'] = new Date(hhgBillOfLadingReview.requiredDeliveryDate).toLocaleDateString();
          }

          hhgBillOfLadingReview['assignedAgent'] = hhgBillOfLadingReview.assignedAgentFirstName + ' ' + hhgBillOfLadingReview.assignedAgentLastName;
          if (this.selectedShipmentType) {
            this.shipmentTypeArray = this.selectedShipmentType.split(' & ');
            for (let i = 0; i < this.shipmentTypeArray.length; i++) {
              if (this.shipmentTypeArray[i] === 'HHG') {
                this.isHhgShipmentType = true;
              }
              if (this.shipmentTypeArray[i] === 'HHG-UAB') {
                this.isUABShipmentType = true;
              }
              if (this.shipmentTypeArray[i] === 'HHG-POV') {
                this.isPOVShipmentType = true;
              }
            }
          }
          /*this.isHhgShipmentType = !(hhgBillOfLadingReview.shipmentType.toUpperCase().indexOf('HHG') < 0);
          this.isUABShipmentType = !(hhgBillOfLadingReview.shipmentType.toUpperCase().indexOf('UAB') < 0);
          this.isPOVShipmentType = !(hhgBillOfLadingReview.shipmentType.toUpperCase().indexOf('POV') < 0);*/
          this.billOfLadingInfo.patchValue(hhgBillOfLadingReview);
        });
      }));

  hhgBillOfLadingDetail$ = this.hhgBillOfLadingService.hhgBillOfLadingDetail$
    .pipe(
      tap(hhgBillOfLadingDetail => {
        setTimeout(() => {
          const billOfLadingDetailForm = this.billOfLadingInfo.get('bolDetails');
          if (!billOfLadingDetailForm) {
            return;
          }
          if (hhgBillOfLadingDetail.travelOrderDate != null) {
            hhgBillOfLadingDetail['travelOrderDateFormated'] = new Date(hhgBillOfLadingDetail.travelOrderDate.substring(0, 10)).toLocaleDateString();
          }
          billOfLadingDetailForm.patchValue(hhgBillOfLadingDetail);
        });
      })
    );

  constructor(private fb: UntypedFormBuilder, private modalService: BsModalService,
              private hhgBillOfLadingService: HhgBillOfLadingService) {
    this.billOfLadingInfo = this.fb.group({
      employeeFirstName: new UntypedFormControl(),
      employeeLastName: new UntypedFormControl(),
      employeeMiddleInitial: new UntypedFormControl(),
      tspName: new UntypedFormControl(),
      scac: new UntypedFormControl(),
      dunsNumber: new UntypedFormControl(),
      assignedAgent: new UntypedFormControl(),
      email: new UntypedFormControl(),
      phone: new UntypedFormControl(),
      phoneExt: new UntypedFormControl(),
      organizationId: new UntypedFormControl(),
      moveDateFormatted: new UntypedFormControl(),
      requestedPackDateFormatted: new UntypedFormControl(),
      requiredDeliveryDateFormatted: new UntypedFormControl(),
      specialRate: new UntypedFormControl(),
      weight: new UntypedFormControl(),
      bolDetails: new UntypedFormGroup({
        travelOrderNumber: new UntypedFormControl('', Validators.required),
        travelOrderDateFormated: new UntypedFormControl('', Validators.required),
        agencyShipmentIdNo: new UntypedFormControl(),
        tspProBillNo: new UntypedFormControl(),
        appropriationChargeCode: new UntypedFormControl('', Validators.required),
        otherAppropriationChargeCode: new UntypedFormControl(),
        povAppropriationChargeCode: new UntypedFormControl(),
        otherPovAppropriationChargeCode: new UntypedFormControl(),
        uabAppropriationChargeCode: new UntypedFormControl(),
        otherUabAppropriationChargeCode: new UntypedFormControl(),
        hhgBolDetailsId: new UntypedFormControl(),
        shipmentsInfoId: new UntypedFormControl(),
        transitTimeExpired: new UntypedFormControl(),
        agencyLocationCode: new UntypedFormControl(),
        pbpeAppropriationChargeCode: new UntypedFormControl()

      })
    });
    this.billOfLadingInfo.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  ngOnInit() {
    // pre-populate Shipment/Booking Types if any
    if (this.selectedShipmentType) {
      this.shipmentTypeArray = this.selectedShipmentType.split(' & ');
      for (let i = 0; i < this.shipmentTypeArray.length; i++) {
        if (this.shipmentTypeArray[i] === 'HHG') {
          this.isHHGSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-UAB') {
          this.isUABSelected = true;
        }
        if (this.shipmentTypeArray[i] === 'HHG-POV') {
          this.isPOVSelected = true;
        }
      }
    }
  }

  onChange: any = () => {
  }
  onTouched: any = () => {
  }

  get value(): any {
    return this.billOfLadingInfo.value;
  }

  set value(value: any) {
    this.billOfLadingInfo.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: UntypedFormControl) {
    return this.billOfLadingInfo.valid ? null : {profile: {valid: false}};
  }

  openAddressVerfiicationDialog() {
    const initialState = {
      modalCalledFrom: 'hhgBOL',
      shipmentInfoId: this.shipmentInfoIdFromUrl
    };
    this.bsModalRef = this.modalService.show(BillofladingAddressesComponent, {initialState, class: 'modal-lg'});
  }
}
